import { isDwellerRole } from '../../../utils/user'

export function isNewsboardPostCommentsDisabledForViewer({ postData, user }) {
  return postData?.comments_forbidden && user && isDwellerRole(user)
}

export function getNewsboardPostProfileTabCommentsPermissions({
  postData,
  user,
}) {
  const canAddComment =
    postData?.permissions?.can_add_comment &&
    !isNewsboardPostCommentsDisabledForViewer({ postData, user })

  return {
    ...postData?.permissions,
    can_send_ai_generated_chat_message: canAddComment,
    can_send_chat_message: canAddComment,
    can_send_templated_chat_message: canAddComment,
  }
}
